require.register("app/restaurant/stat/RangeCARankView", function(exports, require, module){
  $0
  
});

